import React, { useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import axios from 'axios';
import { getHeaders } from '../../../request/index';
import { SttAutocomplete } from '@stt-componentes/core';
import { MUNICIPIO, INSTITUICAO } from '../fieldNames';
import { MODALIDADE } from '../../../common/Constants';
import { useSignal } from '@preact/signals-react';

const Instituicao = ( props ) => {
    const { strings } = props;

    const instituicoes = useSignal([]);
    const { values } = useFormikContext();

    const UTILITARIOS_API_BASE_URL = global.gConfig.url_base_utilitarios;

    useEffect(() => {
        const municipio = values[MUNICIPIO];
        instituicoes.value = [];

        if (municipio) {
            axios.get(
                `${UTILITARIOS_API_BASE_URL}/instituicao-equipamento?municipio=${municipio.id}&modalidade=${MODALIDADE.SIGLA}`, { headers: getHeaders() }
            )
            .then(response => {
                const { itens } = response.data.data;
                instituicoes.value = itens;
            })
            .catch(err => console.log(err));
        }
    }, [values[MUNICIPIO]]);

    return (
        
        <Field name={INSTITUICAO}>
            {({
                field: { name, value, onBlur },
                form: { setFieldValue }
            }) => (
                <SttAutocomplete
                    inputprops={{
                        name: name,
                        label: strings.instituicao
                    }}
                    getOptionLabel={option => option?.nome || ''}
                    getOptionSelected={(option, val) => option?.id === val?.id}
                    options={instituicoes.value}
                    value={value}
                    onBlur={onBlur}
                    onChange={(e, item) => {
                        setFieldValue(INSTITUICAO, item || null);
                    }}
                    disabled={!values[MUNICIPIO]}
                />
            )}
        </Field>
    );
};

export default Instituicao;